module.exports = __webpack_public_path__ + "img/android1icon4.c5efa66c.png";